import axiosInstance from '@/api/axiosInstance';
import { API_PREFIX } from '@/api/endpoints/api.constants';

export type MyTaskType =
  | 'course'
  | 'program'
  | 'certification'
  | 'assignment'
  | 'quiz'
  | 'scorm'
  | 'survey'
  | 'ojt'
  | 'seminar';

export interface MyTask {
  id: string;
  type: MyTaskType;
  title: string;
  context: string;
  due_date: string | null;
  done: boolean;
  url: string;
  /** Activities: the learner's grade (0–100) when there is one. */
  grade?: number | null;
  /** Activities: passed / failed once graded; awaiting = submitted, not graded yet. */
  result?: 'passed' | 'failed' | 'awaiting' | null;
}

export interface MyTasksResponse {
  items: MyTask[];
  total: number;
  pending: number;
}

const browserTimeZone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};

/** The logged-in learner's actionable items for the current month (the month in their own timezone). */
export const MyTasksApi = {
  get: async (): Promise<MyTasksResponse> =>
    (await axiosInstance.get<MyTasksResponse>(`${API_PREFIX}/me/tasks`, { params: { tz: browserTimeZone() } })).data,
};
